import React, {useState, useEffect} from 'react';
import "./Testimonials.scss";
import AppWrap from "../../Wrapper/AppWrap";
import { client, urlFor } from "../../sanity_client/client";
import { 
    HiChevronLeft,
    HiChevronRight,
} from "react-icons/hi";
import { motion } from "framer-motion"

const Testimonials = () => {

    const [testimonials, setTestimonials] = useState([])
    const [indx, setIndx] = useState(0)

    useEffect(()=>{
        const q = '*[_type == "testimonials"]';
        client.fetch(q).then((data)=>{setTestimonials(data)})

    },[])

    const handleClick = (index)=>{
        setIndx(index)
    }

    return (
        <div className="testimonials_section">
            <h2 className="head-text">Testimonials</h2>
            { testimonials.length !== 0 &&(
                <motion.div className="testimonial_container"
                    whileInView={{y:[100,0], opacity:[0,1]}}
                    transition={{
                        duration: 0.6,
                        delay: 0.3,
                    }}
                >
                    <div className="app__testimonial-item">
                        <img src={urlFor(testimonials[indx].imageurl)} alt={testimonials[indx].name}/>
                        <div className="app__testimonial-content">
                            <p className="p-text">{testimonials[indx].feedback}</p>
                            <div>
                                <h4 className="bold-text">{testimonials[indx].name}</h4>
                                <h5 className="p-text">{testimonials[indx].company}</h5>
                            </div>
                        </div>
                    </div>

                    <div className="app__testimonial-btns">
                        <div onClick={()=> handleClick(
                            indx === 0 ? testimonials.length - 1 : indx - 1 )}>
                            <HiChevronLeft />
                        </div>

                        <div onClick={()=> handleClick(
                            indx === testimonials.length - 1 ? 0 : indx + 1
                        )}>
                            <HiChevronRight />
                        </div>
                    </div>
                </motion.div>
            ) }
        </div>
    )
}

export default AppWrap(Testimonials, "testimonials")